/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MoneyAmountWithOptionalGrossFromJSON, MoneyAmountWithOptionalGrossToJSON, } from './MoneyAmountWithOptionalGross';
/**
 * Check if a given object implements the CategorisationIdentifiers interface.
 */
export function instanceOfCategorisationIdentifiers(value) {
    let isInstance = true;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "manufacturer" in value;
    isInstance = isInstance && "price" in value;
    return isInstance;
}
export function CategorisationIdentifiersFromJSON(json) {
    return CategorisationIdentifiersFromJSONTyped(json, false);
}
export function CategorisationIdentifiersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': json['category'],
        'device': !exists(json, 'device') ? undefined : json['device'],
        'manufacturer': json['manufacturer'],
        'price': MoneyAmountWithOptionalGrossFromJSON(json['price']),
    };
}
export function CategorisationIdentifiersToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': value.category,
        'device': value.device,
        'manufacturer': value.manufacturer,
        'price': MoneyAmountWithOptionalGrossToJSON(value.price),
    };
}
